import React from 'react';
import { useParams } from 'react-router-dom';
import WorkPageTemplate from '../../components/work/WorkPageTemplate';

const WorkPage = () => {
  const { id } = useParams();
  return <WorkPageTemplate workId={id} />;
};

export default WorkPage;


